import { z } from "zod";
import { trimmedString } from "../utils/trimmedString";
import { cityRegex, zipCodeRegex } from "../validationRegex";
export const getAddressSchema = (t, opts) => {
    const { customFields } = opts;
    if (!customFields) {
        return z.object({
            street: z.string().nullish(),
            city: z.string().nullish(),
            zipCode: z.string().nullish(),
        });
    }
    return z.object({
        street: trimmedString({
            emptyMessage: t("contact.form.street_error_empty"),
        })
            .min(5, { message: t("contact.form.street_error_empty") })
            .max(160, { message: t("contact.form.street_error_empty") }),
        city: trimmedString({ emptyMessage: t("contact.form.city_error_empty") })
            .min(2, { message: t("contact.form.city_error_empty") })
            .regex(cityRegex, { message: t("contact.form.city_error_empty") })
            .max(80, { message: t("contact.form.city_error_empty") }),
        zipCode: trimmedString({ emptyMessage: t("contact.form.zip_error_empty") })
            .regex(zipCodeRegex, { message: t("contact.form.zip_error_empty") })
            .min(2, { message: t("contact.form.zip_error_empty") })
            .max(10, { message: t("contact.form.zip_error_empty") }),
    });
};
